import {internalProps} from 'src/types/BS_types'

export const isNewCloudImageParametersTab = () =>
  internalProps['teamcity.ui.newCloudImageParametersTab'] ?? true
